import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const addAssignment = (assignment) => {
    // The department selects the assignment company; preserve the client project/task for server-side routing.
    // Creation lifecycle and employee resource belong to the server, including callers other than the admin dialog.
    const { status, isAlreadySignedContract, contractAutoGeneratedType, contractContent, workdayInternalCompanyId, workdayInternalCompanyName, workdayResourceNumber, departmentInternalCompanyName, departmentResourceNumber, ...creation } = assignment;
    const formData = convertModelToFormData(creation);
    if (assignment.projectTaskNumbers?.length) {
        formData.append('projectTaskNumbersJson', JSON.stringify(assignment.projectTaskNumbers));
    }
    return qportalApi.postForm(`Assignment`, formData);
};
const getAssignments = () => {
    return qportalApi.get(`Assignment/getFreelancerAssignments`);
};
const getCurrentAssignments = () => qportalApi.get('Assignment/current');
const getAssignmentsByStatus = (status) => {
    return qportalApi.get(`Assignment/${status}/getFreelancerAssignmentByContractStatus`);
};
const getAssignmentsByMultipleStatuses = (statuses) => {
    const params = statuses.map((s) => `statuses=${s}`).join('&');
    return qportalApi.get(`Assignment/getFreelancerAssignmentsByStatuses?${params}`);
};
const getAssignmentsWithApprovedTimeSheet = () => {
    return qportalApi.get(`Assignment/GetFreelancerAssignmentByApprovedTimeSheet`);
};
const getAssignmentsByStatusWithReason = (status) => {
    return qportalApi.get(`Assignment/${status}/GetFreelancerAssignmentByContractStatusWithReason`);
};
const getAssignmentById = (Id) => {
    return qportalApi.get(`Assignment/${Id}/GetAssignmentById`);
};
const getAssignmentDetailById = (AssignmentId) => {
    return qportalApi.get(`Assignment/${AssignmentId}/getCurrentAssignmentDetail`);
};
const updateAssignment = (assignment) => {
    // Routing is fixed after creation, including when a read DTO is spread into an update model.
    const { departmentInternalCompanyId, departmentInternalCompanyName, departmentResourceNumber, workdayInternalCompanyId, workdayInternalCompanyName, workdayResourceNumber, ...update } = assignment;
    const formData = convertModelToFormData(update);
    if (assignment.projectTaskNumbers?.length) {
        formData.append('projectTaskNumbersJson', JSON.stringify(assignment.projectTaskNumbers));
    }
    return qportalApi.postForm(`Assignment/UpdateAssignment`, formData);
};
const updateAssignmentContract = (assignment) => {
    const formData = convertModelToFormData(assignment);
    return qportalApi.postForm('Assignment/updateAssignmentContract', formData);
};
const updateAssignmentContractEndDate = (assignment) => {
    const formData = convertModelToFormData(assignment);
    return qportalApi.postForm('Assignment/updateAssignmentContractEndDate', formData);
};
const terminateAssignment = (assignmentId) => {
    return qportalApi.post(`Assignment/TerminateAssignment`, { id: assignmentId });
};
const updateAssignmentArchiveStatus = (assignmentId, isArchived) => {
    return qportalApi.post(`Assignment/UpdateArchiveStatus`, { assignmentId, isArchived });
};
const extendAssignment = (assignmentId, extendedDate) => {
    return qportalApi.post(`Assignment/ExtendAssignment`, { assignmentId, extendedDate });
};
const previewContract = async (htmlContent, fileName = 'contract_preview.pdf') => {
    const response = await qportalApi.post('Assignment/PreviewContract', { htmlContent, fileName }, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};
const AssignmentApi = {
    addAssignment,
    getAssignments,
    getCurrentAssignments,
    getAssignmentById,
    getAssignmentsByStatus,
    getAssignmentsByMultipleStatuses,
    getAssignmentDetailById,
    updateAssignment,
    updateAssignmentContract,
    getAssignmentsByStatusWithReason,
    getAssignmentsWithApprovedTimeSheet,
    updateAssignmentContractEndDate,
    terminateAssignment,
    extendAssignment,
    previewContract,
    updateAssignmentArchiveStatus
};
export default AssignmentApi;
